import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3e71ce37"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "map_pagination" }
const _hoisted_2 = { class: "map_pagination_content" }
const _hoisted_3 = { class: "map_pagination_text" }

import SimpleButton from '@/components/atoms/SimpleButton'
import { computed, onMounted, ref, withDefaults } from 'vue'

type PropsType = {
  totalCameras?: number
  currentPage?: number
  pageSize?: number
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MapPagination',
  props: {
    totalCameras: { default: 50 },
    currentPage: { default: 1 },
    pageSize: { default: 10 }
  },
  emits: ["changePage"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'changePage', value: number): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { totalCameras: number, currentPage: number, pageSize: number };

let mapCurrentPage = ref<number>(1)





onMounted(() => {
  mapCurrentPageUPD()
})

const changePage = (button: string) => {
  if (button === 'prev') {
    mapCurrentPage.value--
  } else {
    mapCurrentPage.value++
  }
  emit('changePage', mapCurrentPage.value)
}

const mapCurrentPageUPD = () => {
  mapCurrentPage.value = props.currentPage
}

const totalPage = computed<number>(() => Math.ceil(props.totalCameras / props.pageSize))
const prevDisabled = computed<boolean>(() => mapCurrentPage.value <= 1)
const nextDisabled = computed<boolean>(() => mapCurrentPage.value >= totalPage.value)
const showMapCurrentPage = computed<number>(() => Math.ceil(props.totalCameras / props.pageSize))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createVNode(_unref(SimpleButton), {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (changePage('prev'))),
          color: "color-dark1",
          size: "size-s",
          "icon-size": "30",
          class: "padding_zero",
          "use-border": false,
          disabled: _unref(prevDisabled),
          icon: "keyboard_arrow_left"
        }, null, 8, ["disabled"])
      ]),
      _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(showMapCurrentPage)) + "/" + _toDisplayString(_unref(totalPage)), 1),
      _createElementVNode("div", null, [
        _createVNode(_unref(SimpleButton), {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (changePage('next'))),
          color: "color-dark1",
          size: "size-s",
          "icon-size": "30",
          class: "padding_zero",
          "use-border": false,
          disabled: _unref(nextDisabled),
          icon: "keyboard_arrow_right"
        }, null, 8, ["disabled"])
      ])
    ])
  ]))
}
}

})